import React from 'react'

export default function ExchangeRates() {
  return (
    <div>ExchangeRates</div>
  )
}
